import { render } from "./SubSummery.vue?vue&type=template&id=8664c8ca&scoped=true"
import script from "./SubSummery.vue?vue&type=script&lang=js"
export * from "./SubSummery.vue?vue&type=script&lang=js"

import "./SubSummery.vue?vue&type=style&index=0&id=8664c8ca&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8664c8ca"]])

export default __exports__